import { ChangeEvent } from "react"
import { css, cx } from "@emotion/css"
import { Dot } from "./Dot"

interface IOption {
  label: string
  value: string
}

const styles = {
  root: css`
    display: inline-flex;
    flex-direction: column;
    margin-bottom: 8px;
  `,
  item: css`
    display: flex;
    align-items: center;
    font-size: 0.8175rem;
    line-height: 1rem;
    padding: 4px 0;
    cursor: pointer;
    opacity: 0.4;
  `,
  active: css`
    opacity: 1;
  `,
  hidden: css`
    position: absolute !important;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
    clip: rect(1px, 1px, 1px, 1px);
    white-space: nowrap; /* added line */
  `,
  dot: css`
    margin-right: 8px;
  `,
  label: css`
    text-transform: capitalize;
  `,
  sub: css`
    margin-left: 1ch;
    font-weight: 700;
  `,
}

export interface FilterLegendsOption extends IOption {
  sub?: string
}

type FilterLegendsProps = {
  className?: string
  name: string
  onChange: (evt: ChangeEvent<HTMLInputElement>) => void
  value: string
  options: FilterLegendsOption[]
  getColor: (k: string) => string
  emptyValue: string
}

export function FilterLegends(props: FilterLegendsProps) {
  const { name, onChange, value, options, emptyValue, getColor, className } =
    props

  return (
    <div className={cx(styles.root, className)}>
      {options.map((opt) => {
        const active = value === opt.value || value === emptyValue
        return (
          <label
            key={opt.value}
            className={cx(styles.item, { [styles.active]: active })}
          >
            <input
              name={name}
              className={styles.hidden}
              type="radio"
              value={opt.value}
              onChange={onChange}
              checked={value === opt.value}
            />
            <Dot className={styles.dot} color={getColor(opt.value)} />
            <span className={styles.label}>{opt.label}</span>
            {opt.sub ? <span className={styles.sub}>{opt.sub}</span> : null}
          </label>
        )
      })}
    </div>
  )
}
